type Elements = {
  form: HTMLFormElement | null;
  selector: HTMLSelectElement | null;
};

type NavigationService = {
  navigate: (url: string) => void;
};

type Root = {
  elements: Elements;
  navigation: NavigationService;
  init: () => void;
  handleSubmit: (e: Event) => void;
  handleChange: () => void;
};

const defaultNavigation: NavigationService = {
  navigate: (url: string) => {
    window.location.assign(url);
  }
};

const root: Root = {
  elements: {
    form: null,
    selector: null,
  },

  // Use dependency injection for navigation
  navigation: defaultNavigation,

  init() {
    this.elements.form = document.querySelector('#site-selector');
    this.elements.selector = document.querySelector('#site');

    if (this.elements.form) {
      this.elements.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    if (this.elements.selector) {
      this.elements.selector.addEventListener('change', () => this.handleChange());
    }
  },

  handleSubmit(e: Event) {
    e.preventDefault();
    const selector = this.elements.selector;

    if (!selector) return;

    const selected = selector.options[selector.selectedIndex];

    if (!selected) return;

    const link = selected.dataset.link;
    const secondary = selected.dataset.secondary;
    const key = selected.dataset.key;

    const secondaryLinks = Array.from(document.querySelectorAll('.selector__secondary--links'));
    secondaryLinks.forEach(item => item.classList.remove('show'));

    if (link && secondary === 'false') {
      // Use the navigation service instead of direct window.location
      this.navigation.navigate(link);
    }

    if (secondary === 'true' && key) {
      const links = document.querySelector(`#selection-${key}`);
      if (links) links.classList.add('show');
    }
  },

  handleChange() {
    if (this.elements.selector) {
      this.elements.selector.classList.remove('untouched');
    }
  },
};

export default root;
